import React, { memo, useState } from 'react';
import { FlatList, Text, View } from 'react-native';
import { Image } from "../image/Image";
import { ImageSizeTokens } from "@voltmoney/schema";
/**
 * Primary UI component for user interaction
 */
const RewardWinterComponent = ({ imageUrl, dataList, isMobile }) => {
    const [_isMobile, setIsMobile] = useState(isMobile);
    const newFlow = true;
    const data = [
        {
            id: 1,
            title: "Earn ₹1,000",
            subTitle: "Per referral when the referred MFD becomes activated.",
            iconUrl: "https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/Green_Reward1.png"
        },
        {
            id: 2,
            title: "Earn ₹5000",
            subTitle: "When you successfully activate 3 referrals.",
            iconUrl: "https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/Green_Reward1.png"
        },
        {
            id: 3,
            title: "Earn ₹11,000",
            subTitle: "When you successfully activate 7 referrals.",
            iconUrl: "https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/Green_Reward1.png"
        },
        {
            id: 4,
            title: "Earn ₹19000",
            subTitle: "When you successfully activate 11 referrals.",
            iconUrl: "https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/Green_Reward1.png"
        },
        {
            id: 5,
            title: "Win an iPad + ₹15,000",
            subTitle: "When you successfully activate 15 referrals.",
            iconUrl: "https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/Green_Reward1.png"
        },
        {
            id: 6,
            title: "Earn ₹52,000",
            subTitle: "When you successfully activate 20 referrals.",
            iconUrl: "https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/Green_Reward1.png"
        },
        {
            id: 7,
            title: "Win a Family Trip to Bali",
            subTitle: "When you successfully activate 25 referrals.",
            iconUrl: "https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/Green_Reward1.png"
        }
    ];
    const renderItem = ({ item, index }) => {
        return (React.createElement(View, { style: _isMobile ? {} : {
                flex: 2
            } },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                } },
                React.createElement(Image, { size: ImageSizeTokens.Size_40, uri: item.iconUrl, width: 32, height: 32 }),
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(Text, { style: {
                            fontFamily: 'Inter',
                            fontSize: 18,
                            fontStyle: 'normal',
                            fontWeight: '600',
                            lineHeight: 26,
                        } },
                        React.createElement(Text, { style: { color: '#109648' } }, item.title)),
                    React.createElement(Text, { style: {
                            fontFamily: 'Inter',
                            fontSize: 14,
                            fontStyle: 'normal',
                            fontWeight: '400',
                            lineHeight: 20,
                            color: '#667085',
                        } }, item.subTitle))),
            React.createElement(View, { style: {
                    height: 23
                } })));
    };
    return (React.createElement(View, { style: {
            backgroundColor: '#F9FAFB',
            borderRadius: 8,
            padding: 16,
            display: 'flex',
            flexDirection: _isMobile ? 'column' : 'row',
            width: '100%'
        } },
        React.createElement(View, { style: _isMobile ? {} : {
                flex: 1
            } },
            React.createElement(FlatList, { data: dataList ? dataList : data, renderItem: renderItem, keyExtractor: (item) => item.id })),
        React.createElement(View, { style: _isMobile ? {
                justifyContent: 'center',
                alignItems: 'center'
            } : {
                // flex: 1,
                justifyContent: 'flex-start',
                alignItems: 'center'
            } },
            React.createElement(Image, { size: ImageSizeTokens.Size_40, uri: imageUrl
                    ? imageUrl
                    : 'https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/RewardWinterImage1.png', width: _isMobile ? 312 : 167, height: _isMobile ? 288 : 154 }))));
};
export default memo(RewardWinterComponent);
export { RewardWinterComponent };
